import { render } from "./ConceptBlock.vue?vue&type=template&id=63ea442e&scoped=true"
import script from "./ConceptBlock.vue?vue&type=script&lang=js"
export * from "./ConceptBlock.vue?vue&type=script&lang=js"

import "./ConceptBlock.vue?vue&type=style&index=0&id=63ea442e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63ea442e"
/* hot reload */
if (module.hot) {
  script.__hmrId = "63ea442e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ea442e', script)) {
    api.reload('63ea442e', script)
  }
  
  module.hot.accept("./ConceptBlock.vue?vue&type=template&id=63ea442e&scoped=true", () => {
    api.rerender('63ea442e', render)
  })

}

script.__file = "src/components/blocks/ConceptBlock.vue"

export default script